import { Cell } from 'exceljs';
import { IViewDataFields } from '../Screener/types/screener';
import { fillTemplate } from '../Screener/utils/templates';
import { ColumnsToFormat } from './type';

type InputProps = {
    fieldsViewdata?: IViewDataFields[];
    field: string;
    resultValue: any;
    singleRowData: any;
    columnsToFormat: ColumnsToFormat;
    currentViewColumnName: string;
    isLastRow: boolean;
};

type OutputProps = {
    resultValue: any;
    columnsToFormat: ColumnsToFormat;
};

type HandleCellDynamicNumberFormatTemplate = (props: InputProps) => OutputProps;

export const handleCellDynamicNumberFormatTemplate: HandleCellDynamicNumberFormatTemplate = ({
    fieldsViewdata,
    field,
    resultValue,
    singleRowData,
    columnsToFormat,
    currentViewColumnName,
    isLastRow,
}) => {
    const defaultValue = {
        resultValue,
        columnsToFormat,
    };

    if (!fieldsViewdata) {
        return defaultValue;
    }

    let fieldViewdata = fieldsViewdata?.find((p) => Object.keys(p)['0'] === field)?.[field];

    if (!fieldViewdata || !fieldViewdata.export_cell_dynamic_number_format_template) {
        return defaultValue;
    }

    resultValue = {
        text: resultValue as string,
        numFmt: fillTemplate({
            templateName: 'export_cell_dynamic_number_format_template',
            template: fieldViewdata.export_cell_dynamic_number_format_template || '',
            dataObject: {
                ...singleRowData,
                numberFormat: columnsToFormat[currentViewColumnName]?.numberFormat,
                isRightAligned: true,
            },
            useGetValuesByPathDotsIndependent: true,
        }),
        style: {
            alignment: {
                horizontal: 'right',
            },
        },
    } as Partial<Cell>;

    if (isLastRow) {
        // remove the format on the column level to let the cell level format to be applied
        columnsToFormat[currentViewColumnName] = undefined;
    }

    return {
        resultValue,
        columnsToFormat,
    };
};
